<template>
  <AppBtn primary class="nav-bar-cta py-2" @click="navigate">
    {{ $tt(`nav.cta_${country || 'home'}`) }}
    <CountryFlag
      v-if="country"
      :code="getVisaCountryIsoCode(country)"
      class="ms-2"
    />
  </AppBtn>
</template>

<script setup lang="ts">
import { countryKeyToSlug } from '~/helpers/format';
import { objectKeys } from '~/helpers/general';
import { getHashId } from '~/helpers/routing';
import { VISA_COUNTRIES, getVisaCountryByPath, getVisaCountryIsoCode, getVisaCountryPath } from '~/helpers/visa-country';
import type { BlogPost } from '~/types';

const router = useRouter();
const route = useRoute();
const { blogPost } = useStore();
const { ctaClickBus } = useEmitter();
const countryByBlog = computed(() => getVisaCountryByPost(blogPost.value));
const countryByPath = computed(() => getVisaCountryByPath(route.path));
const country = computed(() => countryByBlog.value || countryByPath.value);

function navigate() {
  if (!country.value) {
    router.push(`/${getHashId('countries_overview')}`);
  }
  else if (countryByBlog.value) {
    const path = getVisaCountryPath(country.value);
    router.push(path);
  }
  else if (countryByPath.value) {
    ctaClickBus.emit();
  }
}

function getVisaCountryByPost(post: BlogPost | null) {
  if (!post) return null;
  const categories = post._embedded['wp:term'][0].map(c => c.slug);
  const countries = objectKeys(VISA_COUNTRIES);
  const country = countries.find(country => categories.some(cat => cat.includes(countryKeyToSlug(country))));
  return country;
}
</script>